import axios from "axios";

export function getProductsTenantPagination(authToken, queryParams) {
    const options = {
        headers: { 'x-auth-token': authToken},
        validateStatus: status => status < 500,
        params: queryParams
    }
    return axios.get(process.env.REACT_APP_API_URL + '/products/buyer/tenant', options);
}
